module.exports = __webpack_public_path__ + "static/media/20-2.38b0ec23.mp3";